// extracted by mini-css-extract-plugin
export default {"h1":"NyA46re_","roboto":"N5QAWsf7"};